import React from 'react';

const PriceDetails = ({ priceInfo, calculatingPrice }) => {
  if (!priceInfo && !calculatingPrice) return null;

  if (!priceInfo && calculatingPrice) {
    return (
      <div className="card bg-light border-0 mb-3">
        <div className="card-body p-3 text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Calculando precio...</span>
          </div>
          <div className="mt-2 text-muted">Calculando precio...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="card bg-light border-0 mb-3">
      <div className="card-body p-3">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h6 className="mb-0">💰 Detalles del precio</h6>
          {calculatingPrice && (
            <div className="spinner-border spinner-border-sm text-primary" role="status">
              <span className="visually-hidden">Calculando...</span>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-6">
            <div className="mb-1">
              <small className="text-muted">Precio original:</small><br />
              <span className="fw-semibold">S/ {priceInfo.original_price}</span>
            </div>
            {priceInfo.discount_percent > 0 && (
              <div className="mb-1">
                <small className="text-muted">Descuento ({priceInfo.discount_percent}%):</small><br />
                <span className="text-success fw-semibold">-S/ {priceInfo.savings}</span>
              </div>
            )}
          </div>
          <div className="col-6 text-end">
            <div className="mb-1">
              <small className="text-muted">Por documento:</small><br />
              <span className="fw-semibold">S/ {priceInfo.price_per_document}</span>
            </div>
            <div className="h5 text-primary mb-0">
              <strong>S/ {priceInfo.final_price}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceDetails;
